/**
 * The local viewer tier override (docs/runbooks/local-viewer-tier.md). Shared so the client's
 * synthetic viewer and the dev GraphQL proxy's Hasura session are the same account. Callers read
 * the env value and check `NODE_ENV` themselves so Next inlines both into the right bundle.
 */
export const DEV_VIEWER_UID = 'dev-viewer-override';

export type DevViewerTier = 'anonymous' | 'free' | 'pro';

export const parseDevViewerTier = (value: string | undefined): DevViewerTier | null =>
  value === 'anonymous' || value === 'free' || value === 'pro' ? value : null;
